<div class="cnt-page-internal">
    <div class="row-title">
        <teiasoft-title [title]="'importMasterdata.title' | translate"></teiasoft-title>
    </div>
    <div class="container">
        <teiasoft-select [labelText]="'importMasterdata.enitity' | translate" [isMobile]="isMobile" [isRequired]="true"
            [disabled]="false" [optionsList]="entitiesOptionList!" [spaceLabel]="true" [disabled]="false"
            [noMinWidth]="true" [isValid]="true" (onSelected)="onSelectedEntity($event)"
            [defaultValue]="this.selectedEntity" [readOnly]="false"></teiasoft-select>
        <teiasoft-select *ngIf="millsOptionList.length > 0" [labelText]="'grid.Mill' | translate" [isMobile]="isMobile"
            [isRequired]="millsOptionList.length > 0" [disabled]="false" [optionsList]="millsOptionList"
            [spaceLabel]="true" [disabled]="false" [noMinWidth]="true" [isValid]="true"
            (onSelected)="onSelectedMill($event)" [defaultValue]="this.selectedMill"
            [readOnly]="false"></teiasoft-select>
        <!-- Hidden file input -->
        <div class="input-file-container">
            <input id="file-upload" class="file-upload-input" type="file" (change)="onFileSelected($event)"
                accept=".xlsx,.xls" />

            <!-- Button styled as a file input trigger -->
            <label for="file-upload" class="teia-button tb-primary file-upload-label"
                [class.disabled]="!selectedEntity || (this.millsOptionList.length > 0 && !this.selectedMill)">
                {{ 'importMasterdata.uploadFile' | translate }}
            </label>
        </div>
        <div class="input-file-container">
            <button (click)="onDownloadClick()" [class.disabled]="!selectedEntity || (this.millsOptionList.length > 0 && !this.selectedMill)"
                class="teia-button tb-secondary file-upload-label">{{ 'importMasterdata.downloadTemplate' | translate
                }}</button>
        </div>
        <div class="input-file-container">
            <button (click)="onDownloadClick(true)" [class.disabled]="!selectedEntity || (this.millsOptionList.length > 0 && !this.selectedMill)"
                class="teia-button tb-secondary file-upload-label">{{ 'importMasterdata.downloadLastVersion' | translate
                }}</button>
        </div>
    </div>
</div>

<teiasoft-modal [theme]="globals.theme!" [isMobile]="!globals.isDesktop!"></teiasoft-modal>
